/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
import { DSDataTableT } from '@elliemae/ds-data-table';
import Grid from '@elliemae/ds-grid';
import { useLookupOptions } from '@frontend/pricing-search';
import { objectOf, shape, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Rights from '../../../../common/services/Rights';
import { handleSelectProductDetails } from '../../../../common/services/sessionHelpers';
import {
  PATH_LOCK_SUMMARY,
  PATH_SCENARIO_SUMMARY,
} from '../../../../route/constants';
import Session, { IS_SCENARIO_MODE } from '../../../../common/services/Session';
import {
  dispApr,
  dispCurrencyMask,
  dispDti,
  dispPrice,
  dispRate,
  shouldDisplayAPR,
} from '../../helpers';
import { StyledBestExProgramLinks, StyledBestExRowSelected } from './styled';

export const DropdownDetails = (props: DSDataTableT.DetailsProps) => {
  const navigate = useNavigate();
  const cols = ['52%', '48%'];
  const program = props.row.original;
  const { rateDetails, setSlide, handleSelectRow } = program;
  const { loanId } = useSelector(({ EPPS }) => EPPS.loanPrograms || {});
  const { loanPrograms } = useSelector(({ EPPS }) => EPPS.loanPrograms || {});
  const dispatch = useDispatch();
  const clientSettings = useLookupOptions('clientSettings');

  const wcpPolicyAppliedFlag = loanPrograms.find(
    (prg: any) => prg.programID === program.target.programID,
  )?.wcpPolicyApplied;

  function handleSelectProduct(
    programID,
    rateDataID,
    lockEffectiveDate,
    wcpPolicyApplied,
  ) {
    handleSelectProductDetails({
      loanId,
      programID,
      rateDataID,
      lockEffectiveDate,
      wcpPolicyApplied,
    });
    navigate(
      Session.get(IS_SCENARIO_MODE) ? PATH_SCENARIO_SUMMARY : PATH_LOCK_SUMMARY,
    );
  }
  const rightAlign = { width: '100%', textAlign: 'right', paddingRight: '3px' };
  const CellValue = ({ value }) => {
    return <span style={rightAlign}>{value}</span>;
  };
  CellValue.defaultProps = {
    value: '',
  };
  CellValue.propTypes = {
    value: string,
  };

  return (
    <>
      <Grid cols={cols}>
        <Grid />
        <Grid>
          <Grid cols={shouldDisplayAPR(clientSettings) ? 7 : 6} tabIndex={0}>
            {rateDetails.map(
              (
                {
                  programID,
                  rateDataID,
                  lockEffectiveDate,
                  wcpPolicyApplied = program.wcpPolicyApplied,
                  rate,
                  price,
                  priceVal,
                  pnI,
                  apr,
                  bRatio,
                  targetRow = program.target.rateDataID === rateDataID &&
                    program.target.programID === programID,
                },
                index,
              ) => (
                <>
                  <Grid
                    height="32px"
                    style={{
                      paddingRight: 8,
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <Grid
                        width="100%"
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <StyledBestExProgramLinks
                          onClick={() => {
                            handleSelectRow(rateDetails[index]);
                            handleSelectProduct(
                              programID,
                              rateDataID,
                              lockEffectiveDate,
                              wcpPolicyApplied,
                            );
                          }}
                        >
                          {dispRate(rate, priceVal)}
                        </StyledBestExProgramLinks>
                      </Grid>
                    </StyledBestExRowSelected>
                  </Grid>
                  <Grid
                    height="32px"
                    style={{
                      paddingRight: 8,
                      fontWeight: targetRow ? 'bold' : '',
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <CellValue value={dispPrice(price, priceVal)} />
                    </StyledBestExRowSelected>
                  </Grid>
                  <Grid
                    height="32px"
                    style={{
                      paddingRight: 8,
                      fontWeight: targetRow ? 'bold' : '',
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <CellValue value={dispCurrencyMask(priceVal)} />
                    </StyledBestExRowSelected>
                  </Grid>
                  <Grid
                    height="32px"
                    style={{
                      paddingRight: 8,
                      fontWeight: targetRow ? 'bold' : '',
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <CellValue value={dispCurrencyMask(pnI)} />
                    </StyledBestExRowSelected>
                  </Grid>
                  {shouldDisplayAPR(clientSettings) && (
                    <Grid
                      height="32px"
                      style={{
                        paddingRight: 8,
                        fontWeight: targetRow ? 'bold' : '',
                      }}
                    >
                      <StyledBestExRowSelected targetRow={targetRow} gridRow>
                        <CellValue value={dispApr(apr)} />
                      </StyledBestExRowSelected>
                    </Grid>
                  )}
                  <Grid
                    height="32px"
                    pr="xxs"
                    style={{
                      fontWeight: targetRow ? 'bold' : 'normal',
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <CellValue value={dispDti(bRatio)} />
                    </StyledBestExRowSelected>
                  </Grid>
                  <Grid
                    height="32px"
                    style={{
                      paddingRight: 8,
                      fontWeight: targetRow ? 'bold' : '',
                    }}
                  >
                    <StyledBestExRowSelected targetRow={targetRow} gridRow>
                      <Grid
                        width="100%"
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <StyledBestExProgramLinks
                          onClick={() => {
                            handleSelectRow(rateDetails[index]);
                            handleSelectProductDetails({
                              programID,
                              loanId,
                              rateDataID,
                              lockEffectiveDate,
                              wcpPolicyApplied,
                            });
                            setSlide({
                              rowData: rateDetails[index],
                              rateData: rateDataID,
                              open: false,
                              data: null,
                            });
                          }}
                        >
                          details
                        </StyledBestExProgramLinks>
                      </Grid>
                    </StyledBestExRowSelected>
                  </Grid>
                </>
              ),
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

DropdownDetails.defaultProps = {
  row: {},
};

DropdownDetails.propTypes = {
  row: objectOf(shape({})),
};
